import apiFetch from '@/api/apiFetch';
import { t } from '@/translations/i18n';

async function postImage(file: File): Promise<string> {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiFetch(`/configuration_images/`, { method: 'POST', body: formData });
    if (response.status === 413) {
        throw new Error(t('image_to_big_error', { name: file.name }));
    }
    if (!response.ok) {
        throw new Error(t('upload_image_error'));
    }
    const responseBody = await response.json();
    return responseBody.uuid;
}

async function fetchImage(imageUUID: string) {
    const response = await apiFetch(`/configuration_images/${imageUUID}`);
    if (!response.ok) {
        throw new Error(t('image_load_error'));
    }
    const blob = response.blob();
    return blob;
}
export { postImage, fetchImage };
